import { useTranslation } from "react-i18next";
import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import { getDiscussById } from '../../../../../../service/course-management';
import Discuss from '../discuss/Discuss';
import "./DetailDiscussionReportModal.scss"

interface Props {
	open?: boolean
	handleCancel?: () => void
	discussionId: number
}

const DetailDiscussionReportModal = (props: Props) => {
  const { t } = useTranslation();
	const { open, handleCancel, discussionId } = props
	const [comments, setComments] = useState<any>();


	const handleOk = () => {
	};

	useEffect(() => {
		const getComments = async () => {
			try {
				const res = await getDiscussById(discussionId)
				setComments(
					{ discussions: [res?.data.data] }
				)

			} catch (error) {

			}
		};
		if (discussionId) {
			getComments();
		}
	}, [discussionId]);
	return (
		<Modal
			centered
			footer={
				null
			}
			title={t("Thảo luận", "Thảo luận")}
			open={open}
			onOk={handleOk}
			onCancel={handleCancel}
			className='detail-discussion-report-modal'
		>
			<Discuss comments={comments} />
		</Modal>
	)
}

export default DetailDiscussionReportModal